import React from "react";
import { IoState, IoStateEnum } from "#store/types";
import { H1, H6 } from "#common/headings";
import { Grid, LinearProgress, Typography } from "@mui/material";
import { Optional } from "#types";
import { Json } from "#common/Json";

export type IoStateComponentProps<T> = {
    iostate: Optional<IoState<T>>;
};

export function IoStateComponentHoc<T>(
    WrappedComponent: React.ComponentType<T>
) {
    return ({ iostate, ...rest }: IoStateComponentProps<T>) => {
        if (!iostate) {
            return null;
        }
        switch (iostate.state) {
            case IoStateEnum.done:
                return <WrappedComponent {...iostate.payload} {...rest} />;
            case IoStateEnum.fetching:
                return (
                    <Grid container>
                        <Grid item xs={12}>
                            <LinearProgress variant={"indeterminate"} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography textAlign={"center"}>
                                Last update: {iostate.timestamp.toString()}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            case IoStateEnum.initialized:
                return (
                    <Grid container>
                        <H1>Initialized</H1>
                    </Grid>
                );
            case IoStateEnum.error:
                return (
                    <>
                        <H6>error</H6>
                        <div>Timestamp: {iostate.timestamp.toString()}</div>
                        <Json src={iostate.state} />
                    </>
                );
        }
    };
}
